import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Projects extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      project: [], 
      overlay: []
    }

  }

  mount() {

     let getRatio = el => window.innerHeight / (window.innerHeight  + el.offsetHeight);


    

     this.ref.project.forEach((section, i) => {
          
            section.bg = section.querySelector(".project__bg");
            
            

            
            // the first image (i === 0) should be handled differently because it should start at the very top.
            // use function-based values in order to keep things responsive
            gsap.fromTo(section.bg, {
                backgroundPosition: () => i ? `100% ${-window.innerHeight * getRatio(section)}px` : "100% 0px"
            }, {
                backgroundPosition: () => `100% ${window.innerHeight * (1 - getRatio(section)) }px`,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: () => i ? "top bottom" : "top top",
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true // to make it responsive
                }
            });


            
            




     })



     

    
}






  unmount() {




  }


}

module.exports = Projects
